import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { FormHelper } from '@helpers/form.helper';
import { AddressModule } from '@shared/address/address.module';
import { IdentifierUpdateModule } from '@shared/identifier-update/identifier-update.module';

import { NotifySettingModule } from '@shared/notify-setting/notify-setting.module';
import { VerifyPhoneNumberModule } from '@shared/verify-phone-number/verify-phone-number.module';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { SelfFilerModule } from '@shared/self-filer/self-filer.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { CompanySharedModule } from '@shared/company-shared/company-shared.module';
import { DocumentModule } from '@shared/document/document.module';
import { IconsModule } from '@shared/icons/icons.module';

import { CompanyRoutingModule } from './company-routing.module';
import { AccountSettingsOrganizationDetailsComponent } from '../organization/pages';
import {
  OrganizationAddressFormComponent,
  OrganizationCompaniesAttachedCardComponent,
  OrganizationContactInformationFormComponent,
  OrganizationDetailsCardComponent,
  OrganizationDetailsEditComponent,
  OrganizationDetailsFormComponent,
  OrganizationLogoFormComponent,
  OrganizationMemberInviteFormComponent,
  OrganizationMembersCardComponent,
  OrganizationPaymentAndBillingCardComponent,
  OrganizationPlanInfoCardComponent,
  OrganizationPlanSelectComponent,
} from '../organization/components';
import {
  AccountSettingsBillingHistoryPageComponent,
  AccountSettingsCompanyDetailedComponent,
  PoaPurchaseComponent,
  AccountSettingsCompanyPageComponent,
  AccountSettingsOrganizationPageComponent,
  AccountSettingsUserDetailsPageComponent,
  AccountSettingsWrapperComponent,
  CompanyBondRequestEditPageComponent,
  CompanyBondRequestPageComponent,
  CompanyBondRequestResultPageComponent,
  CompanyBondRequestViewPageComponent,
  CompanyCbpAssignedNumberRequestApplicationPageComponent,
  CompanyCbpAssignedNumberRequestPageComponent,
  CompanyCbpAssignedNumberRequestStartPageComponent,
  CompanyCbpConnectionComponent,
  CompanyCreatePageComponent,
} from './pages';
import {
  CompanyAddressFormComponent,
  CompanyAllowCustomsComponent,
  CompanyBondRequestFormComponent,
  CompanyBusinessInfoFormComponent,
  CompanyControllingPersonsFormComponent,
  CompanyDutiesPaymentFormComponent,
  CompanyIorContactFormComponent,
  CompanyLogoFormComponent,
  CompanyPhotoIdFormComponent,
  CompanySs4FormComponent,
  CompanyEmployeeStatusComponent,
  CompanyPaymentMethodComponent,
  CompanyPowerAttorneyComponent,
  CompanyPowerAttorneyOldComponent,
  CompanyShareFormComponent,
  CompanyShippingRoleComponent,
  CompanyUserInfoCardComponent,
  CompanyUserPhoneComponent,
  EditCompanyComponent,
  IorMatchConfirmModalComponent,
  PoaIorEditSidebarComponent,
} from './components';
import { MutualModule } from '@shared/mutual/mutual.module';
import { PaymentButtonExternalModule } from '@shared/payment-button-external/payment-button-external.module';
import { CardsModule } from '@shared/cards/cards.module';
import { ResultModule } from '@shared/result/result.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { UserModule } from '@app/modules/user/user.module';
import { PasswordInputModule } from '@shared/password-input/password-input.module';
import { AuthService } from '@app/modules/auth/services';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { InputPhoneModule } from '@shared/input-phone/input-phone.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaymentButtonSharedModule } from '@shared/payment-button-shared';
import { PaymentSharedModule } from '@shared/payment-shared';
import { MissingFieldsModule } from '@shared/missing-fields/missing-fields.module';
import { OrganizationServicesPaymentPreferenceCardComponent } from '../organization/components/organization-services-payment-preference-card/organization-services-payment-preference-card.component';
import { BillingHistorySharedModule } from '@shared/billing-history/billing-history.module';
import { NgxsModule } from '@ngxs/store';
import { UserBillingState } from './state/billing';
import { ActionBoxComponent } from '@app/shared/components';
import { CbpNumberRequestSharedModule } from '@shared/cbp-number-request/cbp-number-request-shared.module';
import { ConfirmModalModule } from '@app/shared/components/confirm-modal/confirm-modal.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    CompanyRoutingModule,
    TranslateModule,
    BsDatepickerModule,
    AddressModule,
    NotifySettingModule,
    IdentifierUpdateModule,
    ModalModule,
    BsDropdownModule.forRoot(),
    NgxsModule.forFeature([UserBillingState]),
    NgxIntlTelInputModule,
    VerifyPhoneNumberModule,
    CustomModalModule,
    SelfFilerModule,
    PipesSharedModule,
    CompanySharedModule,
    DocumentModule,
    FormWrapperModule,
    IconsModule,
    MissingFieldsModule,
    MutualModule,
    PaymentButtonExternalModule,
    CardsModule,
    ResultModule,
    TooltipModule.forRoot(),
    TabsModule,
    UserModule,
    PasswordInputModule,
    InputPhoneModule,
    NgSelectModule,

    PaymentButtonSharedModule,
    PaymentSharedModule,
    BillingHistorySharedModule,
    CbpNumberRequestSharedModule,
    ConfirmModalModule,
  ],
  declarations: [
    PoaPurchaseComponent,
    OrganizationDetailsCardComponent,
    OrganizationDetailsEditComponent,
    OrganizationDetailsFormComponent,
    OrganizationAddressFormComponent,
    OrganizationContactInformationFormComponent,
    OrganizationLogoFormComponent,
    OrganizationCompaniesAttachedCardComponent,
    OrganizationMembersCardComponent,
    OrganizationMemberInviteFormComponent,
    OrganizationPaymentAndBillingCardComponent,
    OrganizationPlanSelectComponent,
    OrganizationPlanInfoCardComponent,
    OrganizationServicesPaymentPreferenceCardComponent,
    CompanyCreatePageComponent,
    CompanyCbpConnectionComponent,
    CompanyCbpAssignedNumberRequestPageComponent,
    CompanyCbpAssignedNumberRequestStartPageComponent,
    CompanyCbpAssignedNumberRequestApplicationPageComponent,
    CompanyLogoFormComponent,
    CompanyPhotoIdFormComponent,
    CompanySs4FormComponent,
    CompanyBondRequestFormComponent,
    CompanyBondRequestPageComponent,
    CompanyBondRequestEditPageComponent,
    CompanyBondRequestViewPageComponent,
    CompanyBondRequestResultPageComponent,
    CompanyShippingRoleComponent,
    CompanyAddressFormComponent,
    CompanyBusinessInfoFormComponent,
    CompanyControllingPersonsFormComponent,
    CompanyDutiesPaymentFormComponent,
    CompanyIorContactFormComponent,
    CompanyPowerAttorneyComponent,
    CompanyPowerAttorneyOldComponent,
    CompanyAllowCustomsComponent,
    CompanyUserPhoneComponent,
    CompanyShareFormComponent,
    CompanyUserInfoCardComponent,
    EditCompanyComponent,
    AccountSettingsWrapperComponent,
    AccountSettingsUserDetailsPageComponent,
    AccountSettingsOrganizationPageComponent,
    AccountSettingsBillingHistoryPageComponent,
    AccountSettingsOrganizationDetailsComponent,
    AccountSettingsCompanyPageComponent,
    AccountSettingsCompanyDetailedComponent,
    CompanyPaymentMethodComponent,
    PoaIorEditSidebarComponent,
    IorMatchConfirmModalComponent,
    CompanyEmployeeStatusComponent,
    ActionBoxComponent,
  ],
  providers: [FormHelper, AuthService],
  exports: [CompanyPowerAttorneyComponent],
})
export class CompanyModule {}
